<template>
    <div class="lb-accordion" style="overflow:hidden">
        <div ref="collapsibles-questions" id="accordion_questions" class="pb-4 pt-0">
            
            <article class="message" v-for="(question,index) in questions" :key="index">
                <div class="message-header has-text-black">
                    <a
                        style="width: 100%"
                        :ref="'information'+index"
                        @click="toggle('information'+index)"
                        class="question-group"
                        :rel="'accordion_questions-information'+index"
                    >
                        <nav class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <div class="level-item section-title">
                                        <span class="icon-text">
                                            <span class="icon is-medium">
                                                <i
                                                    class="mdi mdi-32px mdi-timeline-question-outline has-color-eduloc-blue"
                                                ></i>
                                            </span>
                                            <span class="ml-2 mt-1">
                                                {{
                                                    $t(
                                                        'object_group_question'
                                                    )
                                                }} {{index+1}}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="level-right">
                                <div class="level-item">
                                    <span
                                        :ref="'information'+index+'-icon'"
                                        class="icon is-medium mr-1"
                                    >
                                        <i
                                            class="mdi mdi-32px mdi-plus" 

                                        ></i>
                                    </span>
                                </div>
                            </div>
                        </nav>
                    </a>
                </div>
                <div
                    :id="'accordion_questions-information'+index"
                    class="message-body new-questions px-0 py-0"
                >
                    <div class="message-body-content pb-0 px-0 pt-0 ">
                       
                    <l-project-object-question
                            :model="questionModel"
                            :content="question"
                            :objectType="'question'"
                            :index="index"
                            :showHelp="false"
                            
                            @updateHeight="updateHeight"
                        />
                        <div
                            v-if="canDelete && question._id"
                            class="delete-button is-pulled-right px-2 pb-2 mr-2"
                        >
                            <a @click="deleteQuestion(question)" class="primary-font button is-primary is-inverted">
                                <span class="pr-4 is-size-6">{{ $t('remove_question') }}</span>
                                <span class="icon"
                                    ><i
                                        class="mdi mdi-32px mdi-close-circle"
                                        aria-hidden="true"
                                    ></i
                                ></span>
                            </a>
                        </div>
                    </div>
                </div>
            </article>

        </div>
        <div class="mx-6">
            <button @click="addNewQuestion" class="button is-eduloc-orange is-fullwidth primary-font">{{$t('object_group_new_question')}}</button>
        </div>

        <div v-if="errorsOnSave" class="validationErrors px-5">
            <div class="notification is-danger is-light">
                <button class="delete" @click="errorsOnSave = false"></button>
                <p class="has-text-weight-bold is-size-6 pb-2">
                    {{ $t('Object.errors_on_save') }}
                </p>
                <p class="is-size-6">
                    {{ $t('Object.errors_on_save_desc') }}
                </p>
                <br />
                <div
                    class="is-size-6 has-text-italic"
                    v-for="(errorIndex, index) in questions"
                    :key="index"
                >
                    <br />
                    <p v-if="hasErrors(index)" class="has-text-weight-bold">{{$t('object_group_question')}} {{index+1}}</p>
                    <p
                        class="is-size-6 has-text-italic"
                        v-for="(error, index) in objectErrors[index]"
                        :key="index"
                    >
                        - {{ error }}
                    </p>
                </div>
            </div>
        </div>

        <div class="action-buttons-container mb-2">
            <a @click="discardUnsavedChanges" class="button is-primary">
                <span class="icon is-small my-2"
                    ><i
                        class="mdi mdi-32px mdi-chevron-double-left"
                        aria-hidden="true"
                    ></i
                ></span>
            </a>
            <a
                @click="showPreview"
                class="button is-eduloc-yellow primary-font is-size-5"
            >
                {{ $t('show_object') }}
            </a>
            <a
                @click="validateAndSave"
                class="button is-primary primary-font is-size-5"
            >
                {{ $t('Buttons.save') }}
            </a>
           
        </div>
    </div>

</template>

<script>
import bulmaCollapsible from '@creativebulma/bulma-collapsible';
import _ from 'underscore';
import LProjectObjectQuestion from '@/components/LProjectObjectQuestion';

export default {
    name: 'LProjectObjectQuestions',
    components: {
        LProjectObjectQuestion
    },
    props: {
        content: {
            type: Array,
            default() {
                return [];
            },
        },
        canDelete: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            collapsiblesQuestions: undefined,
            originalContent: [],
            questions: [],
            objectErrors: [],
            filesErrors: [],
            audioErrors: [],
            imagesErrors: [],
            errorsOnSave: false,
            defaultLang: this.$store.getters.project.defaultLang ? this.$store.getters.project.defaultLang : '',
        };
    },
    computed: {
        
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        
        hasChanges() {
            return this.content !== this.originalContent;
        },
        
        questionModel(){
            return this.$store.getters.questionModel;
        },
        isMultiLang() {
            return this.$store.getters.project.langs && this.$store.getters.project.langs.length > 0;  
        },
    },

    mounted() {
        this.originalContent = [ ...this.content ];
        this.questions = [...this.content];
        // console.log("questions", this.questions)
        if (this.isMultiLang) {
            this.questions.forEach((question) => { 
                if (this.questionModel.title && !question.titlePerLang) {
                    question.titlePerLang = {};
                    /*if (this.project.langs) {
                        this.project.langs.forEach((langCode) => {
                            //console.log(langCode)
                            this.contentDraft.titlePerLang
                        })
                    }*/
                }
                if (this.questionModel.description &&!question.DescriptionPerLang) {
                    question.descriptionPerLang = {};
                }

                const mediaFiles = _.chain(this.questionModel.media)
                    .pluck('name')
                    .concat()
                    .value();

                mediaFiles.forEach((prop) => { 
                    // console.log(prop)
                    if (prop == 'video' && !question.videoPerLang) { 
                        question.videoPerLang = {};
                    }
                    if (prop == 'url' && !question.urlPerLang) { 
                        // console.log("setting url")
                        question.urlPerLang = {};
                    }
                    if (prop == 'files' && !question.filesPerLang) { 
                        question.filesPerLang = {};
                    }
                    if (prop == 'audio' && !question.audioPerLang) { 
                        question.audioPerLang = {};
                    }
                });

                if (this.questionModel.related) {
                    // console.log("related", this.questionModel.related)
                    this.questionModel.related.forEach((element) => { 
                        // console.log("checking ",element.name)
                        if (element.name == "answersPerLang" && !question.answersPerLang) {
                            question.answersPerLang = {}
                        }
                    })
                    
                }
            });
            
        }
        
    },
    beforeDestroy() {
    },
    destroyed() {},
    methods: {
        updateHeight(index){
            // console.log("height recived",index)
            // let contentDiv = document.getElementById('accordion_questions-information'+index);
            // contentDiv.style.marginRight="-15px"
            // contentDiv.style.overflowY="scroll"

            /*setTimeout(() => {
                contentDiv.style.maxHeight = contentDiv.scrollHeight + "px";
            }, 300);*/
            
        },
        toggle(option){
            //console.log("option",option,this.$refs[option][0].classList)
            let contentDivs=document.getElementsByClassName('new-questions');
            // console.log(contentDivs)
            let i;
            let contentDiv = document.getElementById('accordion_questions-'+option);
            for (i = 0; i < contentDivs.length; i++) {
                // console.log('checking',contentDivs[i])
                if(contentDivs[i].getAttribute("id")!=contentDiv.getAttribute("id")){
                    // console.log(contentDivs[i].classList)
                    if(contentDivs[i].classList.contains('active')){
                        contentDivs[i].classList.remove('active');
                        contentDivs[i].style.maxHeight = null;
                        this.$refs[`information${i}-icon`][0].childNodes[0].classList.remove('mdi-minus');
                        this.$refs[`information${i}-icon`][0].childNodes[0].classList.add('mdi-plus');
                        let linkDiv = document.querySelectorAll('[rel="'+contentDivs[i].getAttribute("id")+'"]');
                        if(linkDiv){
                            linkDiv[0].classList.toggle('active');
                        }
                    }
                }
            }
            
            if (this.$refs[option][0].classList.contains('active')) {
                this.$refs[`${option}-icon`][0].childNodes[0].classList.remove('mdi-minus');
                this.$refs[`${option}-icon`][0].childNodes[0].classList.add('mdi-plus');
                if(contentDiv){
                    contentDiv.style.maxHeight = null;
                    this.$refs[option][0].classList.remove('active')
                    contentDiv.classList.remove('active')
                }
            } else {
                this.$refs[`${option}-icon`][0].childNodes[0].classList.remove('mdi-plus');
                this.$refs[`${option}-icon`][0].childNodes[0].classList.add('mdi-minus');
                if(contentDiv){
                    contentDiv.style.maxHeight = "100%"//contentDiv.scrollHeight + "px";
                    this.$refs[option][0].classList.add('active')
                    contentDiv.classList.add('active')
                }
            }
        },
        addNewQuestion(){
        // console.log("emiting from projectObjectQuestions")
            // console.log(this.questions.length)
            if (this.isMultiLang) {
                let question={
                    'owner':{},
                    'answers':[],
                }
                if (this.questionModel.title) {
                    question.titlePerLang = {};
                }
                if (this.questionModel.description &&!question.DescriptionPerLang) {
                    question.descriptionPerLang = {};
                }

                const mediaFiles = _.chain(this.questionModel.media)
                    .pluck('name')
                    .concat()
                    .value();

                mediaFiles.forEach((prop) => { 
                    // console.log(prop)
                    if (prop == 'video') { 
                        question.videoPerLang = {};
                    }
                    if (prop == 'url') { 
                        // console.log("setting url")
                        question.urlPerLang = {};
                    }
                    if (prop == 'files') { 
                        question.filesPerLang = {};
                    }
                    if (prop == 'audio') { 
                        question.audioPerLang = {};
                    }
                });

                if (this.questionModel.related) {
                    // console.log("related", this.questionModel.related)
                    this.questionModel.related.forEach((element) => { 
                        // console.log("checking ",element.name)
                        if (element.name == "answersPerLang") {
                            question.answersPerLang = {}
                        }
                    })
                    
                }
                this.questions.push(question);
                
            } else {
                this.questions.push({
                    'owner':{},
                    'answers':[],
                });
            }
            
        },
        deleteQuestion(question){
            // console.log("delete question",question)
            let questionIndex = _.findIndex(this.questions, {'_id':question._id});
            // console.log("question to delete",questionIndex)
            if(questionIndex!=-1){
                this.questions.splice(questionIndex, 1);
            }
        },
        discardUnsavedChanges(){
            this.$emit('cancel');
        },
        showPreview(){
            // console.log("questions to send",this.questions)
            this.$emit("showPreview",this.questions)
        },
        hasErrors(index){
            return !_.isEmpty(this.objectErrors[index])
        },
        validateAndSave() {
            // console.log("validating")
            let responseValidator;
            let requiredMedia = _.chain(this.questionModel.media)
                .filter((media) => media.required)
                .pluck('name')
                .concat()
                .value();
            let requiredProps = _.chain(this.questionModel)
                .pick((value, key) => {
                    return value.required;
                })
                .keys()
                .value();  
            let requiredFields = requiredProps.concat(requiredMedia);
            let props = _.chain(requiredFields);
            let dataLenght = 0;
            let isValid;

            // console.log("required fields",requiredFields)

            this.questions.forEach((question, index) => {
                
                // console.log("validating question",index,question)
                delete this.objectErrors[index];
                responseValidator = this.questionValidator(question, index);
                if (responseValidator !== 'ALL_OK') {
                    // alert(this.$t(responseValidator));
                    //return;
                    this.errorsOnSave = true;
                }
                props.forEach((prop) => {
                    // console.log("prop",prop)
                    if (question[prop]) {

                        dataLenght = 0;
                        if (typeof question[prop] == 'object') {
                            dataLenght = Object.keys(question[prop]).length;
                        } else {
                            dataLenght = question[prop].lenght;
                        }
                        if (dataLenght === 0) {

                            this.objectErrors[index][prop] = this.$t(
                                `Object.missing_${prop}_value`
                            );


                        } else {
                            if (this.objectErrors[index][prop]) {
                                delete this.objectErrors[index][prop];
                            }
                        }
                        if (prop === 'title') { 
                            if (this.isMultiLang) {
                                if (this.$store.getters.project.defaultLang && question.titlePerLang[this.$store.getters.project.defaultLang]) {
                                    question.title = question.titlePerLang[this.$store.getters.project.defaultLang];
                                }
                                if (!question.titlePerLang[this.$store.getters.project.defaultLang] || !question.titlePerLang[this.$store.getters.project.defaultLang].length) {
                                    this.objectErrors[index][prop] = this.$t(`missing_${prop}_value_default_lang`);
                                }  
                                delete this.objectErrors[index][prop];
                            }
                        }
                    } else {
                        if (prop === 'title') { 
                            if (this.isMultiLang) {
                                if (!question.titlePerLang[this.$store.getters.project.defaultLang] || !question.titlePerLang[this.$store.getters.project.defaultLang].length) {
                                    // console.log("adding error")
                                    this.objectErrors[index]['lang_'+this.$store.getters.project.defaultLang] = this.$t(`missing_${prop}_value_default_lang`);
                                } else {
                                    question.title = question.titlePerLang[this.$store.getters.project.defaultLang];
                                    
                                    delete this.objectErrors[index]['lang_'+this.$store.getters.project.defaultLang]
                                } 
                                delete this.objectErrors[index][prop];
                            }
                        } else {
                            this.objectErrors[index][prop] = this.$t(
                                `Object.missing_${prop}_value`
                            );
                        }
                        /*if ("title" != prop) {
                            this.objectErrors[index][prop] = this.$t(
                                `Object.missing_${prop}_value`
                            );
                        }*/
                    }

                    if (this.isMultiLang) { 
                        // console.log("comprovant camps multilingüe", question)
                        let checkAudio = false;
                        let checkVideo = false;
                        let checkUrl = false;
                        let checkFiles = false;

                        let languages = this.$store.getters.project.langs;
                        let defaultLang = this.$store.getters.project.defaultLang;
                        let contentToCheck = { ...question }
                        languages.forEach(function (lang) { 
                            // console.log("coprovant",lang,contentToCheck)
                            if (contentToCheck.audioPerLang && contentToCheck.audioPerLang[lang]) {
                                if (lang != defaultLang) {
                                    checkAudio = true;
                            }  
                            }
                            if (contentToCheck.videoPerLang && contentToCheck.videoPerLang[lang]) {
                                if (lang != defaultLang) {
                                    checkVideo = true;
                                }  
                            }
                            if (contentToCheck.urlPerLang && contentToCheck.urlPerLang[lang]) {
                                if (lang != defaultLang) {
                                    checkUrl = true;
                            }  
                            }
                            if (contentToCheck.filesPerLang && contentToCheck.filesPerLang[lang]) {
                                if (lang != defaultLang) {
                                    checkFiles = true;
                            }  
                            }
                        })
                        if (checkAudio) {
                            // console.log("hi ha audio")  
                            if (!question.audioPerLang[this.$store.getters.project.defaultLang]) {
                                this.objectErrors[index]['audio_lang_'+this.$store.getters.project.defaultLang] = this.$t(`missing_audio_value_default_lang`);
                            } else {
                                delete this.objectErrors[index]['audio_lang_' + this.$store.getters.project.defaultLang];
                            }
                        }
                        if (checkVideo) {
                            // console.log("hi ha video")  
                            if (!question.videoPerLang[this.$store.getters.project.defaultLang]) {
                                this.objectErrors[index]['video_lang_'+this.$store.getters.project.defaultLang] = this.$t(`missing_video_value_default_lang`);
                            } else {
                                delete this.objectErrors['video_lang_' + this.$store.getters.project.defaultLang];
                            }
                        }
                        if (checkFiles) {
                            // console.log("hi han arxius")  
                            if (!question.filesPerLang[this.$store.getters.project.defaultLang]) {
                                this.objectErrors[index]['files_lang_'+this.$store.getters.project.defaultLang] = this.$t(`missing_files_value_default_lang`);
                            } else {
                                delete this.objectErrors[index]['files_lang_' + this.$store.getters.project.filesLang];
                            }
                        }
                        if (checkUrl) {
                            // console.log("hi ha url")  
                            if (!question.urlPerLang[this.$store.getters.project.defaultLang]) {
                                this.objectErrors[index]['url_lang_'+this.$store.getters.project.defaultLang] = this.$t(`missing_url_value_default_lang`);
                            } else {
                                delete this.objectErrors[index]['url_lang_' + this.$store.getters.project.urlLang];
                            }
                        }
                    }

                    isValid = Object.keys(this.objectErrors[index]).length === 0;
                    if (Object.keys(this.objectErrors[index]).length === 0) {
                        // this.$emit('save');
                        // console.log('(pas 1) has valid questions',this.questions);
                        //this.$emit('save',this.questions);
                    } else {
                        this.errorsOnSave = true;
                    }

                });
                
            });

            if(!this.errorsOnSave){
                // console.log("(pas 1) sending save",this.questions)
                this.$emit('save',this.questions);
            }
            // console.log(this.errorsOnSave,this.objectErrors)
                        
        },
        questionValidator(question, index) {
            if (!this.isMultiLang) {
                if (this.objectErrors[index]) {
                    if (this.objectErrors[index]['answers']) {
                        delete this.objectErrors['answers'];
                    }
                    if (this.objectErrors[index]['question']) {
                        delete this.objectErrors['question'];
                    }
                    if (this.objectErrors[index]['questionType']) {
                        delete this.objectErrors['questionType'];
                    }
                } else {
                    this.objectErrors[index] = {};
                }
                if (!question.title) {
                    //return 'Object.errors.FILL_QUESTION';
                    this.objectErrors[index]['question'] = this.$t(
                        `Object.errors.FILL_QUESTION`
                    );
                }

                if (!question.answerType) {
                    this.objectErrors[index]['questionType'] = this.$t(
                        `Object.errors.QUESTION_TYPE`
                    );
                    return;
                }

                // console.log(this.content.answers, this.correctAnswers);
                if (
                    question.answerType == 'HANGMAN' ||
                    question.answerType == 'FREETEXT' ||
                    question.answerType == 'NUMERIC'
                ) {
                    if (!question.answers || !question.answers.length) {
                        // console.log('hangman, freetext no answer');
                        // return 'Object.errors.FILL_ANSWER';
                        this.objectErrors[index]['answers'] = this.$t(
                            `Object.errors.FILL_ANSWER`
                        );
                        return;
                    }

                    if (this.correctAnswers(question).length) {
                        this.cleanedAnswers(question); // removes emtpy answers
                        question.answers = [this.correctAnswers(question)[0]]; // ensure only one answer for this question type
                    } else {
                        // return 'Object.errors.MARK_CORRECT';
                        // console.log('hangman, freetext no correct');
                        this.objectErrors[index]['answers'] = this.$t(
                            `Object.errors.MARK_CORRECT`
                        );
                        return;
                    }
                } else if(question.answerType == 'SINGLE' || question.answerType == 'MULTIPLE'){
                    if (!question.answers || !question.answers.length) {
                        // return 'Object.errors.FILL_ANSWERS';
                        // console.log('simple, multiple no answers');
                        this.objectErrors[index]['answers'] = this.$t(
                            `Object.errors.FILL_ANSWERS`
                        );
                        return;
                    }
                    question.answers = this.cleanedAnswers(question); // removes emtpy answers
                    // console.log(this.correctAnswers, this.content.answers);
                    if (this.correctAnswers(question).length < 1) {
                        // console.log('simple, multiple no correct');
                        //return 'Object.errors.MARK_CORRECT';
                        this.objectErrors[index]['answers'] = this.$t(
                            `Object.errors.MARK_CORRECT`
                        );
                        return;
                    }
                } else if (question.answerType == 'RANGE') {

                    if (!question.answers || !question.answers.length) {
                        // console.log('hangman, freetext no answer');
                        // return 'Object.errors.FILL_ANSWER';
                        this.objectErrors[index]['answers'] = this.$t(
                            `Object.errors.FILL_ANSWER`
                        );
                        return;
                    }

                    if (this.correctAnswers(question).length) {
                        this.cleanedAnswers(question); // removes emtpy answers
                        question.answers = [this.correctAnswers(question)[0]]; // ensure only one answer for this question type
                    } else {
                        // return 'Object.errors.MARK_CORRECT';
                        // console.log('hangman, freetext no correct');
                        this.objectErrors[index]['answers'] = this.$t(
                            `Object.errors.MARK_CORRECT`
                        );
                        return;
                    }

                }
                return 'ALL_OK';
            } else {
                console.log("comprovant respostes")
                const langs = this.$store.getters.project.langs;

                if (this.objectErrors[index]) {
                    if (this.objectErrors[index]['answersPerLang']) {
                        delete this.objectErrors['answersPerLang'];
                    }
                    if (this.objectErrors[index]['question']) {
                        delete this.objectErrors['questionPerLang'];
                    }
                    if (this.objectErrors[index]['questionType']) {
                        delete this.objectErrors['questionType'];
                    }
                } else {
                    this.objectErrors[index] = {};
                }
                if (!question.titlePerLang) {
                    //return 'Object.errors.FILL_QUESTION';
                    this.objectErrors[index]['question'] = this.$t(
                        `Object.errors.FILL_QUESTION_DEFAULT_LANG`
                    );
                } else {
                    if (!question.titlePerLang[this.defaultLang]) {
                        this.objectErrors[index]['question'] = this.$t(
                            `Object.errors.FILL_QUESTION_DEFAULT_LANG`
                        );
                    }  
                }

                if (!question.answerType) {
                    this.objectErrors[index]['questionType'] = this.$t(
                        `Object.errors.QUESTION_TYPE`
                    );
                    return;
                }

                // console.log(this.content.answers, this.correctAnswers);
                if (
                    question.answerType == 'HANGMAN' ||
                    question.answerType == 'FREETEXT' ||
                    question.answerType == 'NUMERIC'
                ) {
                    if (!question.answersPerLang) {
                        // console.log('hangman, freetext no answer');
                        // return 'Object.errors.FILL_ANSWER';
                        this.objectErrors[index]['answers'] = this.$t(
                            `Object.errors.FILL_ANSWER`
                        );
                        return;
                    }else {
                        if (!question.answersPerLang[this.defaultLang]) {
                            this.objectErrors[index]['answers'] = this.$t(
                                    `Object.errors.FILL_ANSWER_DEFAULT_LANG`
                                );    
                        }  
                    }

                    if (this.correctAnswersPerLang(question,this.defaultLang).length) {
                        this.cleanAnswersPerLang(this.defaultLang,question); // removes emtpy answers
                        question.answersPerLang[this.defaultLang] = [this.correctAnswersPerLang(question,this.defaultLang)[0]]; // ensure only one answer for this question type
                    } else {
                        // return 'Object.errors.MARK_CORRECT';
                        // console.log('hangman, freetext no correct');
                        this.objectErrors[index]['answers'] = this.$t(
                            `Object.errors.MARK_CORRECT`
                        );
                        return;
                    }
                } else if (question.answerType == 'RANGE') { 
                    console.log("checking range")
                    if (!question.answersPerLang) {
                        // console.log('hangman, freetext no answer');
                        // return 'Object.errors.FILL_ANSWER';
                        this.objectErrors[index]['answers'] = this.$t(
                            `Object.errors.FILL_ANSWER`
                        );
                        return;
                    }else {
                        if (!question.answersPerLang[this.defaultLang]) {
                            this.objectErrors[index]['answers'] = this.$t(
                                    `Object.errors.FILL_ANSWER_DEFAULT_LANG`
                                );    
                        }  
                    }
// console.log(this.correctAnswersPerLang(question,this.defaultLang))
                    if (this.correctAnswersPerLang(question,this.defaultLang).length) {
                        this.cleanAnswersPerLang(this.defaultLang,question); // removes emtpy answers
                        question.answersPerLang[this.defaultLang] = [this.correctAnswersPerLang(question,this.defaultLang)[0]]; // ensure only one answer for this question type
                    } else {
                        // return 'Object.errors.MARK_CORRECT';
                        // console.log('hangman, freetext no correct');
                        this.objectErrors[index]['answers'] = this.$t(
                            `Object.errors.MARK_CORRECT`
                        );
                        return;
                    }
                } else {
                    if (!question.answersPerLang) {
                        // return 'Object.errors.FILL_ANSWERS';
                        console.log('simple, multiple no answers');
                        this.objectErrors[index]['answers'] = this.$t(
                            `Object.errors.FILL_ANSWERS`
                        );
                        return;
                    }else if (!question.answersPerLang[this.defaultLang]||!question.answersPerLang[this.defaultLang].length) {
                        // return 'Object.errors.FILL_ANSWERS';
                        console.log('simple, multiple no answers on default lang');
                        this.objectErrors[index]['answers'] = this.$t(
                            `Object.errors.FILL_ANSWERS`
                        );
                        return;
                    }
                    langs.forEach((codeLang) => {
                        this.cleanAnswersPerLang(codeLang,question);
                    });
                    //question.answers = this.cleanedAnswers(question); // removes emtpy answers
                    // console.log(this.correctAnswers, this.content.answers);
                    if (this.correctAnswersPerLang(question,this.defaultLang).length < 1) {
                        // console.log('simple, multiple no correct');
                        //return 'Object.errors.MARK_CORRECT';
                        this.objectErrors[index]['answers'] = this.$t(
                            `Object.errors.MARK_CORRECT`
                        );
                        return;
                    }else if (this.correctAnswersPerLang(question,this.defaultLang) && this.correctAnswersPerLang(question,this.defaultLang).length < 1) {
                        // console.log('simple, multiple no correct');
                        //return 'Object.errors.MARK_CORRECT';
                        this.objectErrors['answers'] = this.$t(
                            `Object.errors.MARK_CORRECT`
                        );
                        return;
                    }
                }
                return 'ALL_OK';
                
            }
        },
        cleanAnswersPerLang(codeLang,question) {
            question.answersPerLang[codeLang] = this.cleanedAnswersPerLang(question,codeLang);
        },
        correctAnswersPerLang(question,langCode) {
            // console.log('object', this.content);
            // console.log('answers', this.content.answers);
            // console.log('answerType', this.content.answerType);

            // console.log(this.content.answersPerLang[langCode])
            return _.filter(question.answersPerLang[langCode], (answer) => {
                // console.log("answer",answer)
                if (answer.correct) {
                    // return answer && answer.value;
                    // console.log("correct answer", answer.value, answer.valueMin,answer.valueMax)
                    
                    return answer && (answer.value || (answer.valueMin && answer.valueMax));
                }
            });
        },
        cleanedAnswersPerLang(question, langCode) {
            // console.log("question", question)
            // console.log("langCode",langCode)
            return _.filter(question.answersPerLang[langCode], (answer) => {
                //if (answer.value) {
                if (answer.value ||(answer.valueMin && answer.valueMax)) {
                    return answer;
                }
            });
        },
        correctAnswers(question) {
            // console.log('object', this.content);
            // console.log('answers', this.content.answers);
            // console.log('answerType', this.content.answerType);
            return _.filter(question.answers, (answer) => {
                if (answer.correct) {
                    // return answer && answer.value;
                    return answer && (answer.value || (answer.valueMin && answer.valueMax));
                }
            });
        },
        cleanAnswers(question) {
            question.answers = this.cleanedAnswers(question);
        },
        cleanedAnswers(question) {
            return _.filter(question.answers, (answer) => {
                // if (answer.value) {
                if (answer.value ||(answer.valueMin && answer.valueMax)) {
                    return answer;
                }
            });
        },
    },
};
</script>

<style scoped>
    @import '~tippy.js/animations/shift-away.css';
    @import '../assets/css/tippyeduloc.css';
    @import '~vue2-dropzone/dist/vue2Dropzone.min.css';

    .lb-accordion{
        max-height: unset;
    }
    .lb-accordion .message-header{
        background-color: white;
    }
    .lb-accordion .message-header .icon{
        color: var(--eduloc-blue);
    }
    .lb-accordion .message-header .active{
        background-color: var(--eduloc-blue-light);
    }
    .message {
        background-color: transparent;
        border-radius: 0;
        font-size: 1rem;
        margin-bottom: 0;
    }
    .message
        a:not(.button):not(.lb-button):not(.lb-toolbar-button_images):not(.lb-toolbar-button_video):not(.lb-toolbar-button_files):not(.lb-toolbar-button_audio):not(.lb-toolbar-button_url):not(.lb-toolbar-button_location):not(.lb-toolbar-button_tags):not(.lb-toolbar-button_question):not(.lb-toolbar-button_object):not(.lb-toolbar-button_point):not(.lb-delete-media):not(.lb-answer):not(.lb-multiple-answer):not(.tag):not(.lb-bain-tag-functional):not(.lb-bain-tag-emotional):not(.lb-bain-tag-life-changer):not(.lb-bain-tag-social-impact):not(.lb-role-tag_administrator):not(.lb-role-tag_teacher):not(.lb-role-tag_student):not(.lb-role-tag_coordinator):not(.lb-role-tag_participant):not(.lb-role-tag_facilitator):not(.lb-status-tag_active):not(.lb-status-tag_inactive):not(.lb-status-tag_invited):not(.dropdown-item) {
        text-decoration: none;
    }
    .message-body.is-collapsible {
        overflow-x: hidden;
    }

    .new-questions {
  
        background-color: white;
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.2s ease-out;
    }

    .validationErrors{
        position: absolute;
        left: 20px;
        right: 20px;
        top: 20px;
    }
    .question-group{
        padding-left: 2rem !important;
    }

</style>
